import colors from '@/src/theme/colors';
import styled from 'styled-components';

export const VendorsQuantity = styled.span<{ isDesktop: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  padding: 0 0 12px 16px;
  color: ${() => colors.night_blue_1};
  ${({ isDesktop }) =>
    isDesktop &&
    `
    padding: 0 !important;
  `};

  span {
    font-family: 'Segma';
  }
`;

export const PartnerListContainer = styled.div<{
  isDesktop: boolean;
  showFilters: boolean;
  isAndroid?: boolean;
  isNewVersion?: boolean;
}>`
  display: flex;
  flex-direction: column;
  ${({ showFilters, isAndroid, isNewVersion }) => {
    if (showFilters) {
      if (isAndroid && isNewVersion) {
        return `padding: calc(9.5% + 52px) 0 48px 0;`;
      }
      return `padding: 96px 0 48px 0;`;
    }
    return `padding: 0 0 48px 0;`;
  }};

  ${({ isDesktop }) => isDesktop && `padding-left: 16px;`};
`;

export const ContainerDropdown = styled.div`
  width: 300px;
`;

export const ChipCarrouselContainer = styled.div.attrs(() => ({
  'data-testid': 'chip-carrousel-container',
}))<{ showFilters; isiOS; isAndroid?; isNewVersion?; theme }>`
  width: 100%;
  ${({ showFilters, isiOS, isAndroid, isNewVersion, theme }) => {
    // Default value for non-iOS or non-revamp
    let topValue = '44px';

    // Default value for revamp on non-iOS
    if (!isiOS) {
      topValue = '43px';
    }

    if (isAndroid && isNewVersion) {
      topValue = '9.5%';
    }

    return showFilters
      ? `
        opacity: 1;
        z-index: 9999 !important;
        background-color: #FFFFFF;
        justify-content: center;
        align-items: center;
        flex: 1;
        position: fixed;
        top: ${topValue};
        width: 100%;
        transition: all 300ms ease;
        box-shadow: 0 6px 8px 0 rgba(16, 4, 35, 0.12);

        ${
          isiOS
            ? `
                // Non-notched iOS devices
                @media ${theme.mediaQueries.mobileIos} {
                  top: 62px !important;
                }

                // iPhone X/XS/11 Pro
                @media ${theme.mediaQueries.mobileIosNotch} {
                  top: 80px  !important;
                }

                // iPhone XR/11
                @media ${theme.mediaQueries.mobileIosNotchMax} {
                  top: 85px !important;
                }

                // iPhone 14 Pro
                @media only screen
                  and (device-width: 393px)
                  and (device-height: 852px)
                  and (-webkit-device-pixel-ratio: 3) {
                    top: 85px !important;
                }

                // iPhone 12/13 Series
                @media only screen
                  and (device-width: 390px)
                  and (device-height: 844px)
                  and (-webkit-device-pixel-ratio: 3) {
                    top: 86px !important;
                }

                // iPhone 14 Pro Max
                @media only screen
                  and (device-width: 430px)
                  and (device-height: 932px)
                  and (-webkit-device-pixel-ratio: 3) {
                    top: 88px !important;
                }
              `
            : ''
        }
      `
      : '';
  }}
`;
export const SkeletonQuantity = styled.div`
  padding: 0 0 12px 16px;
`;

export const ContainerChipCarouselS = styled.div.attrs(() => ({
  'data-testid': 'chip-carrousel-container-revamp',
}))<{ showFilters }>`
  ${({ showFilters }) =>
    showFilters ? 'padding: 12px 0 8px 0;' : 'padding: 24px 16px 20px 0;'}
`;

export const ContainerPartnerList = styled.div<{
  isDesktop: boolean;
}>`
  display: flex;
  ${({ isDesktop }) =>
    isDesktop
      ? 'padding-top: 32px; flex-direction: row'
      : 'padding-top: 0; flex-direction: column'}
`;
